angular.module('unergie.main')
.directive('salesTunnelCompanyInformationV3', (mapUtils, MetaWatcher, DraftsBasic, ErrorCatcher) => ({
    restrict: 'E',
    scope: {
        draft: '=',
        user: '=',
        checks: '=',
        draftServices: '=',
        disableContractEdition: '=',
        draftState: '=',
    },
    templateUrl: '/states/salesTunnelV3/component/salesTunnelCompanyInformationV3.html',
    link($scope) {
        $scope.saveDraft = MetaWatcher.notif.bind(null, 'SALES_TUNNEL.SAVE_DRAFT')
        $scope.form = {}
        $scope.billingForm = {}
        $scope.isLegalNameEditDisabled = true
        $scope.isBusinessCodeEditDisabled = true
        $scope.isSiretValid = false
        $scope.isLoadingCompanyInformation = false
        $scope.billingForm = {
            bill_addr_num_street: _.get($scope.draft, 'bill_addr_num_street', undefined),
            bill_addr_post_code: _.get($scope.draft, 'bill_addr_post_code', undefined),
            bill_addr_city_lbl: _.get($scope.draft, 'bill_addr_city_lbl', undefined),
        }

        // VALIDATORS
        const initComponentValidator = () =>
            MetaWatcher.notif('SALES_TUNNEL.SET_VALIDATORS', {
                isSiretDefined(store) {
                    return !_.isEmpty(store.draft.siret) && store.draft.siret.length === 14
                },
                isLegalNameDefined(store) {
                    return !_.isEmpty(store.draft.legal_name)
                },
                isBusinessCodeDefined(store) {
                    return !_.isEmpty(store.draft.business_code)
                },
            })

        $scope.$watch('draft', (draft, previousDraft) => {
            const isAccountCategoryUpdated = $scope.draft.account_category && mapUtils.hasDifference(draft, previousDraft, ['account_category'])
            if (draft.siret && $scope.form.siret !== draft.siret) {
                $scope.form.siret = _.get(draft, 'siret', undefined)
                $scope.validateSiret()
            }
            $scope.billingForm = {
                bill_addr_num_street: _.get(draft, 'bill_addr_num_street', undefined),
                bill_addr_post_code: _.get(draft, 'bill_addr_post_code', undefined),
                bill_addr_city_lbl: _.get(draft, 'bill_addr_city_lbl', undefined),
            }
            $scope.displayBillingAddressForm = ($scope.draft.bill_addr_city_lbl != null && $scope.draft.bill_addr_post_code != null && $scope.draft.bill_addr_num_street != null)
            if (isAccountCategoryUpdated) {
                initComponentValidator()
            }
        })

        $scope.isFormDisabled = $scope.form.siret && $scope.form.legal_name && $scope.form.business_code

        $scope.validateSiret = () => {
            if ($scope.form.siret && $scope.form.siret.length === 14) {
                $scope.isLoadingCompanyInformation = true
                $scope.errorMessage = undefined
                // plum siret for testing 83817598200019
                return DraftsBasic.getCompanyInformation({ id_draft_basic: $scope.draft.id, siret: $scope.form.siret })
                .$promise.then((companyInformation) => {
                    $scope.isSiretValid = true
                    $scope.form.legal_name = companyInformation.legal_name
                    $scope.form.business_code = companyInformation.business_code
                    $scope.isBusinessCodeEditDisabled = true
                    $scope.isLegalNameEditDisabled = true
                    $scope.saveDraft({ siret: $scope.form.siret, legal_name: $scope.form.legal_name, business_code: $scope.form.business_code })
                })
                .catch((error) => {
                    $scope.isSiretValid = false
                    $scope.form.legal_name = undefined
                    $scope.form.business_code = undefined
                    if (error.status === 404) {
                        $scope.errorMessage = `Le SIRET n'a pas été trouvé dans la base de l'INSEE, êtes vous sûr qu'il est correct ? Si oui complétez les informations ci dessous :`
                        $scope.isBusinessCodeEditDisabled = false
                        $scope.isLegalNameEditDisabled = false
                        $scope.saveDraft({ siret: $scope.form.siret, legal_name: null, business_code: null })
                    } else {
                        return ErrorCatcher(error)
                    }
                })
                .finally(() => {
                    $scope.isLoadingCompanyInformation = false
                })
            }
        }

        const activate = () => {
            initComponentValidator()
        }
        activate()
    },
}))
